export default __webpack_public_path__ + "static/media/error-msg.f188a6e2.jpg";